import { Component, OnInit, ViewEncapsulation, Output, EventEmitter } from '@angular/core';
import { ReactiveFormsModule,FormGroup, FormControl,FormBuilder } from '@angular/forms';
import { FilterColumn } from '../../../model/FilterColumn';
import { routerTransition } from '../../../../../../router.animations';
import { NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap/datepicker/ngb-date-parser-formatter';
import { NgbDateLocalParserFormatter } from '../../../../../providers/NgbDateLocalParserFormatter';


@Component({
  selector: 'app-filter-form',
  templateUrl: './filter-form.component.html',
  styleUrls: ['./filter-form.component.scss'],
  encapsulation: ViewEncapsulation.None,
  inputs:["formConfig:formConfig","hideButtons:hideButtons"],    
  animations: [routerTransition()] 
})
export class FilterFormComponent implements OnInit {

  public form: FormGroup=null;
  private _formConfig:Array<FilterColumn>=null;
  private _hideButtons:boolean=false;
  public _visible:boolean = false;

  public listData={};

  @Output() onSearch = new EventEmitter<FormGroup>();
  @Output() onReset = new EventEmitter<void>();
  @Output() onCreate = new EventEmitter<FilterFormComponent>();  


  ngOnInit() {

    /*this._formConfig = [
        new FilterColumn("Code","","string","code","text","none","",false,"EQ"),
        new FilterColumn("Title","","string","title","text","none","",false,"CT"),
        new FilterColumn("Email","","string","email","text","none","",false,"CT"),
        new FilterColumn("Enabled","","boolean","enabled","boolean","","",true,"EQ")
      ];

      var fbcols = Array<any>();

      this._formConfig.forEach((column,idx)=>{
          fbcols[column.field_name] = new FormGroup({
              op: new FormControl(column.default_operator),
              value1: new FormControl(),
              value2: new FormControl()
          });
      });

      this.form = this.fb.group(fbcols);*/
  }

  constructor(private fb: FormBuilder) {      
   }

  public get formConfig():Array<FilterColumn>
  {
      return this._formConfig;
  }

  public toggleVisible()
  {      
      this._visible = !this._visible;
  }

  public opvalue(control_name)
  {
      var ctrl=this.form.get(control_name);
      return ctrl.get('op').value;
  }

  get localDateFormat():string
  {
      return  new NgbDateLocalParserFormatter().selectedFormat;
  }

  public set formConfig(config: Array<FilterColumn>)
  {     
    var fbcols = Array<any>();
    this._formConfig=config;

    this._formConfig.forEach((column,idx)=>{

        if(column.list_data!=null)
        {
            this.listData[column.field_name]=[];
            column.list_data.subscribe(
                data=>this.listData[column.field_name]=data.items
            )
        }

        fbcols[column.field_name] = new FormGroup({
            op: new FormControl(column.default_operator),
            value1: new FormControl( column.default_value1 ),
            value2: new FormControl( column.default_value2 )
        });
    });

    this.form = this.fb.group(fbcols);  
    this.onCreate.emit(this);    
   }  

   public set hideButtons(newValue:boolean)
   {
        this._hideButtons = newValue;
   }

   public get hideButtons():boolean
   {
       return this._hideButtons;
   }

  public get configKeys():Array<number>
  {
    if(this._formConfig==undefined)  return [];  
    return Array.from(this._formConfig.keys());
  }

  public doSearch()
  {
      this.onSearch.emit(this.form);      
  }

  public doReset()
  {
      this.onReset.emit();
      this.form.reset();
  }

  public getMinDate(config:FilterColumn)
  {
      if(config.options!=null && config.options['minDate']!==undefined)
      {
            return config.options['minDate'];
      }
      else      
        {
            var dt= new Date();
            dt.setFullYear(dt.getFullYear()-10);
            var ret =     
            {
                'year': dt.getFullYear(),
                'month': dt.getMonth()+1,
                'day': dt.getDate()
            };       
            
            return ret;
        }
  }

}



// WEBPACK FOOTER //
// I:/Yog/Projects/Web/LetterDev/wwwroot/ManagerApp/wwwroot/src/app/shared/modules/crud/crud-list/components/filter-form/filter-form.component.ts